import { render } from "./ContactoFlotante.vue?vue&type=template&id=e1aead70"
import script from "./ContactoFlotante.vue?vue&type=script&lang=js"
export * from "./ContactoFlotante.vue?vue&type=script&lang=js"

import "./ContactoFlotante.vue?vue&type=style&index=0&id=e1aead70&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__